import { DataTable } from "@components/DataTable/DataTable"
import { useSerializedAccountData } from "@apis/accounts/useAccounts"
import {
  tableColumnsInvoicesCondensed,
  tableColumnsInvoicesFull,
} from "./tableColumnSchema"
import { cn } from "@components/ui/lib/utils"
import { Button } from "@components/ui/button"
import { useTabParams } from "@hooks/useTabParams"

type TGetLinkedAccountsProps = {
  account_id: string
  condensed?: boolean
}

export const Invoices = ({
  account_id,
  condensed = false,
}: TGetLinkedAccountsProps) => {
  const { data, isError, error, isPending } =
    useSerializedAccountData(account_id)
  const { setTab } = useTabParams()

  if (isError) {
    return (
      <div className="tw:text-red-500">
        There was an error loading Invoices. Error: {error.message}
      </div>
    )
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-4">
      <div
        className={cn(
          "tw:flex",
          condensed ? "tw:items-center tw:gap-6" : "tw:flex-col tw:gap-1",
        )}
      >
        <h4 className="tw:mb-0 tw:text-xl tw:font-semibold">Invoices</h4>

        {condensed ? (
          <Button
            variant="default"
            size="sm"
            onClick={() => setTab("invoices")}
          >
            View All
          </Button>
        ) : (
          !!data?.invoiceData.length && (
            <p className="tw:m-0">
              <strong>Average Rate with Inspire:</strong>{" "}
              {data.invoiceData[0].avg_rate_formatted}
            </p>
          )
        )}
      </div>
      <div
        className={cn("tw:overflow-y-scroll", {
          "tw:scrollbar-always-visible":
            (data?.invoiceData?.length ?? 0) > 6 && condensed,
          "tw:max-h-[300px]": condensed,
          "tw:max-h-[600px]": !condensed,
        })}
      >
        <DataTable
          columns={
            condensed ? tableColumnsInvoicesCondensed : tableColumnsInvoicesFull
          }
          data={data?.invoiceData ?? []}
          pending={isPending}
          classes="tw:w-full"
        />
      </div>
    </div>
  )
}
